<template>

  <div v-if="printProject" class="web-print-header">
    <div class="web-print-title">{{ (printProject.altname ? printProject.altname + ' · ' : '') + printProject.name + (printProject.description ? ' · ' + printProject.description : '') }}</div>
    <div class="web-print-meta">
      <span>Personalplan Ausgabedatum </span><strong>{{ formatDateDDMMYYYY(new Date(), '.') }}</strong>
      <span class="web-print-sep">Zeitraum:</span><strong>{{ formatDateDDMMYYYY(startDate, '.') }} – {{ formatDateDDMMYYYY(endDate, '.') }}</strong>
    </div>
  </div>

  <div  class="scheduler-wrapper">

	<div ref="cornerRef">	<Corner :printProject="printProject"
            :configs="props.configs" :projectFilter="projectFilter" @setProjectFilter="handleSetProjectFilter" @zoom="handleZoom" />
    </div>
    <div ref="sidebarRef" :style="{height: printProject ? 'fit-content' : 'auto'}" :class="{printview: printProject}" class="sidebar" id="sidebar"  @scroll="syncScroll('left')">
		<ProjectHeader
		    v-for="(p, i) in displayProjects"
		    :project="p"
	         :isprintView="printProject || false"
			:users="props.users"
			:bookings="displayBookings"
			:projects="props.projects"
			:isopen="view.isOpenProject(p.id)"
			:resourceFilter="resourceFilter[p.id]"
			@updateResourceFilter="handleUpdateResourceFilter"
			@update="updateProjectOpenstates"
			@print-view="handlePrintAction"
		  />
	</div>
    <div ref="timesheetRef" class="main-scroll-area" id="main-scroll-area"  @scroll="syncScroll('right')">
      <Timeaxis :key="`${startDate.getTime()}-${endDate.getTime()}`" :printProject="printProject" :startDate="startDate" :endDate="endDate" @deselect="closeSelection" :bookings="displayBookings"/>
	  <div class="timesheet" id="timesheet">
	    <ProjectTimesheet
      :key="`${p.id}-${startDate.getTime()}-${endDate.getTime()}`"
		  :startDate="startDate"
		  :endDate="endDate"
	      v-for="p in displayProjects"
	      :project="p"
	      :isprintView="(printProject && printProject.id === p.id) || false"
	      :projects="props.projects"
	      :users="props.users"
	      :bookings="displayBookings"
	      :isopen="view.isOpenProject(p.id)"
	      :resourceFilter="resourceFilter[p.id]"
	      :configs="props.configs"
	      @bookingDone="handleBookingDone"
	      @projectChangeDone="projectChangeDone"
	      @cancel="handleCancel"
	      @deselect="closeSelection"
	    />
	    <HighlightDays :startDate="startDate" :endDate="endDate" :isprintView="printProject !== null" :configs="props.configs" />
	    <div v-if="!printProject" id="today-line" class="today-line"> </div>
	    <div v-if="!printProject" id="selection-layer" class="selection-layer"></div>
	  </div>
    </div>
	
	<Callout id="projecttimePopup" :target="popupTarget" :show="showPopup" :arrow="true" @close="closePopup" >

	  <!-- Context menu: only for bookings -->
	  <div v-if="popupMode === 'context'" style="min-width: 200px;" class="flex flex-col gap-2">
	    <p style="font-size: 11px; color: #888; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; padding: 0 2px;">Buchung ändern</p>
	    <button class="w-full text-center px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-black" @click="popupMode = 'datechange'">Zeitraum ändern</button>
	    <button class="w-full text-center px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-black" @click="popupMode = 'moveproject'">In anderes Projekt verschieben</button>
	    <button class="w-full text-center px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-red-600 font-medium" @click="handleDeleteFromContext">Buchung löschen</button>
	  </div>

	  <!-- Zeitabschnitte eines Projekts (TIM-38): beliebig viele, dazwischen Pausen -->
	  <div v-if="popupMode === 'datechange' && popupType === 0" style="min-width: 300px;">
	    <p>Projektzeitraum ändern</p>
	    <div v-for="(row, i) in periodRows" :key="`period-${i}`" class="flex flex-wrap items-center gap-1.5 mb-1.5">
	      <DateInput label="von" :modelValue="row.start" @datechange="(v) => row.start = v" />
	      <DateInput label="bis" :modelValue="row.end" @datechange="(v) => row.end = v" />
	      <button v-if="periodRows.length > 1"
	              class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none"
	              title="Abschnitt entfernen"
	              @click="periodRows.splice(i, 1)">−</button>
	    </div>
	    <button class="text-sm text-gray-600 hover:underline mb-2" @click="addPeriodRow()">+ Abschnitt</button>
	    <p class="text-xs text-gray-500 mb-2">Pausen unter einer Woche werden zusammengefasst.</p>
	    <button
	      class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
	      @click="handlePeriodsApply()"
	    >
	      <span>Anwenden</span>
	    </button>
	  </div>

	  <!-- Date change popup: bookings -->
	  <div v-if="popupMode === 'datechange' && popupType === 1">
	    <p>Buchungszeitraum ändern</p>
	    <div style="display:flex; align-items:center; gap:4px;">
	      <button @click="handleStartDateChange(shiftDate(entityStartDate, -1))" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">‹</button>
	      <DateInput label="Start" :modelValue="entityStartDate" :max="entityEndDate" @datechange="handleStartDateChange" />
	      <button @click="handleStartDateChange(shiftDate(entityStartDate, 1))" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">›</button>
	    </div>
	    <div class="spacer"/>
	    <div style="display:flex; align-items:center; gap:4px;">
	      <button @click="handleEndDateChange(shiftDate(entityEndDate, -1))" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">‹</button>
	      <DateInput label="Ende" :modelValue="entityEndDate" :min="entityStartDate" @datechange="handleEndDateChange" />
	      <button @click="handleEndDateChange(shiftDate(entityEndDate, 1))" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">›</button>
	    </div>
	    <div class="spacer"/>
	    <button
	      class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
	      @click="handleDateChangeApply()"
	    >
	      <span>Anwenden</span>
	    </button>
	  </div>

	  <!-- Move project popup: bookings only -->
	  <div v-if="popupMode === 'moveproject'">
	    <p style="font-size: 11px; color: #888; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px;">In Projekt verschieben</p>
	    <div style="max-height: 220px; overflow-y: auto;">
	      <div v-for="p in popupProjects" :key="p.id"
	        :style="{
	          display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0',
	          cursor: p.id === popupProjects[0]?.id || compatibleProjectIds.has(p.id) ? 'pointer' : 'not-allowed',
	          opacity: p.id === popupProjects[0]?.id || compatibleProjectIds.has(p.id) ? '1' : '0.35'
	        }"
	        @click="(p.id === popupProjects[0]?.id || compatibleProjectIds.has(p.id)) && (selectedPopupProjectId = p.id)"
	      >
	        <input type="radio" :checked="selectedPopupProjectId === p.id"
	          :disabled="p.id !== popupProjects[0]?.id && !compatibleProjectIds.has(p.id)"
	          style="cursor:inherit;" />
	        <span :style="{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: p.color, flexShrink: 0, display: 'inline-block' }"></span>
	        <span style="font-size: 13px;">{{ p.id === popupProjects[0]?.id ? p.name + ' (belassen)' : p.name }}</span>
	      </div>
	    </div>
	    <div class="spacer"/>
	    <button
	      class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
	      @click="handleMoveApply()"
	    >
	      <span>Verschieben</span>
	    </button>
	  </div>

	</Callout>
	
	<BookingSelectionPopup ref="selectionPopupRef"
	                      :projects="displayProjects"
						  :users="props.users"
						  :bookings="displayBookings"
						  :xScale="xScaleRef"
						  :days="daysRef"
						  @bookingDone="handleBookingDone"
						  @dateupdate="handleDateUpdate"
						  @close="closeSelection" />
						  
    <ConfirmModal ref="confirmModal" :message="modalMessage" :colsitems="modalColsItems" :items="modalItems" :cancelable="modalCancelable" />
	<ConflictModal ref="conflictModal" />

	<div v-if="printProject" class="print-footer">
        <div class="footer-content">
            <button type="button" class="footer-btn" @click="handleDownloadPdf(printProject)">
                <Printer :size="24" />
                <span>PDF Drucken</span>
            </button>
            <button type="button" class="footer-btn secondary" @click="handleRestorePlanner">
                <ArrowBigLeft :size="24" />
                <span>Zurück</span>
            </button>
        </div>
    </div>
  </div>

  <Transition name="undo-btn">
    <button
      v-if="undoStack.length > 0 || undoGesperrt"
      :disabled="undoGesperrt"
      @click="performUndo"
      class="fixed bottom-6 right-6 z-[9998] w-12 h-12 rounded-full bg-timin text-black flex items-center justify-center shadow-lg transition-transform"
      :class="undoGesperrt ? 'opacity-40 cursor-not-allowed' : 'hover:brightness-90 active:scale-95'"
      :title="undoGesperrt
        ? 'Diese Änderung lässt sich nicht rückgängig machen: dabei wurden bestehende Buchungen gekürzt oder gelöscht.'
        : 'Rückgängig (Strg+Z)'"
    >
      <Undo2 :size="20" />
    </button>
  </Transition>

  <div v-if="isLoading" class="fixed inset-0 z-[10001] flex items-center justify-center bg-black/10 pointer-events-auto">
    <div class="animate-spin rounded-full h-10 w-10 border-4 border-white/40 border-t-timin"></div>
  </div>

  <div v-if="isGenerating" class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
    <Card class="w-[300px] p-6 text-center">
      <div class="mb-4 font-bold text-sm">PDF wird generiert...</div>
      
      <div class="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
        <div 
          class="bg-timin h-full transition-all duration-300 ease-out"
          :style="{ width: progress + '%' }"
        ></div>
      </div>
      
      <div class="mt-2 text-xs text-muted-foreground">{{ Math.round(progress) }}%</div>
    </Card>
  </div>

</template>

<script setup lang="ts">
import {onMounted, computed, ref, provide, watch, nextTick } from 'vue';
import {useViewStore} from "@/stores/viewStore"
import * as d3 from 'd3';
import {scrollToDate, daysBetween, getHalfYearRange, getQuarterRange, getMonthRange, nextDay, positionTodayLine, cleanx, stopAutoScroll, handleAutoScroll, getWeekBounds, generateTiledPdf, sortProjects, removeSelections, computeResourceFilter, sendRequest, prepProject, prepBooking, projectPeriods, dayMs, getWidthPerDay, getRowHeight, box2int, setDim, getProjectFromRow, xToIso, formatDateDDMMYYYY, validateProjectDuration, findNearestConflict, clipRangeAgainstConflict} from "./planner.js";
import {fromIso, toGerman, fromGerman, addDays, toIsoLocal} from '@/utils/dateUtils';
import BookingSelectionPopup from './BookingSelectionPopup.vue'
import Corner from './Corner.vue'
import Timeaxis from './Timeaxis.vue'
import ProjectHeader from './ProjectHeader.vue'
import ProjectTimesheet from './ProjectTimesheet.vue'
import HighlightDays from './HighlightDays.vue'
import ConfirmModal from './ConfirmModal.vue'
import ConflictModal from './ConflictModal.vue'
import DateInput from "./DateInput.vue"
import Callout from './Callout.vue'
import { Card } from "@/components/ui/card"
import { Printer, ArrowBigLeft, Undo2 } from "lucide-vue-next"
import { colscollisions } from '../timintables/colscollisions'
import { POPUP_BUS } from './popupBus'

const props = defineProps({
  projects: { type: Array, required: true },
  bookings: { type: Array, required: true },
  users: { type: Array, required: true },
  configs: { type: Array, required: true },
});

const cornerRef = ref(null);
const sidebarRef = ref(null);
const timesheetRef = ref(null)

const isGenerating = ref(false);
const progress = ref(0); // 0 to 100

const handleDownloadPdf = async (project) => {
  if (!timesheetRef.value) return;
  
  isGenerating.value = true;
  progress.value = 0; // Reset progress
  
  try {
    const { default: html2canvas } = await import('html2canvas');
    const { jsPDF } = await import('jspdf');

    // Pass a callback to update progress
    await generateTiledPdf(project,
      timesheetRef.value,
      cornerRef.value,
      sidebarRef.value,
      html2canvas,
      jsPDF,
      view.zoomWidthPerDay,
      startDate.value,
      endDate.value,
      (p) => { progress.value = p; }
    );
    
  } catch (error) {
    console.error("PDF Generation failed:", error);
  } finally {
    // Small delay so the user sees "100%" before it vanishes
    setTimeout(() => {
      isGenerating.value = false;
      progress.value = 0;
    }, 500);
  }
};

const view = useViewStore();
view.setCountActiveUsers(props.users.filter(u => u.role_id > 0 && u.is_active === 1).length)

const selectionPopupRef = ref(null)
const confirmModal = ref(null)
const conflictModal = ref(null)
const modalColsItems = ref(null)
const modalItems = ref([])
const modalMessage = ref("Bestätigen")
// Nur bei echten Rueckfragen bekommt der Dialog einen Abbrechen-Knopf.
const modalCancelable = ref(false)
const projectFilter = ref({all: view.showAllBookings(), active: view.showActiveProjects(), planned: view.showPlannedProjects()})
const xScaleRef = ref(null);
const daysRef = ref([]);

const isLoading = ref(false)

const printProject = ref<any>(null)
const printStart = ref(null)
const printEnd = ref(null)

const startDateStr = props.configs.find(c => c.name === "startdate").value;
const endDateStr = props.configs.find(c => c.name === "enddate").value;

const initialStartDate = new Date(startDateStr + "T00:00:00");
const initialEndDate = new Date(endDateStr   + "T00:00:00");

const activeZoomVal = ref(0)
const activeZoomStart = ref(initialStartDate)
const activeZoomEnd = ref(initialEndDate)

const startDate = ref<Date>(initialStartDate)
const endDate   = ref<Date>(initialEndDate)

let widthPerDay = getWidthPerDay(printProject.value !== null, view.zoomWidthPerDay)
const totalDays = (endDate.value.getTime() - startDate.value.getTime()) / dayMs;

const x = d3.scaleUtc().domain([startDate.value, endDate.value]).range([0, totalDays * widthPerDay]);

xScaleRef.value = x;

const dayWidth = cleanx(x, new Date(2024, 0, 2)) - cleanx(x, new Date(2024, 0, 1));

watch(
  [printStart, printEnd],
  async ([ps, pe]) => {
	console.log("watch printStart, printEnd=" + ps + " " + pe)
    if (ps && pe) {
      // If ps is already a Date object, don't append the time string
      // Achsen-Grenzen bleiben lokale Mitternacht (Raster von d3.timeDay).
      startDate.value = ps instanceof Date ? ps : new Date(fromGerman(ps) + "T00:00:00");
      endDate.value   = pe instanceof Date ? pe : new Date(fromGerman(pe) + "T00:00:00");
    } else {
      startDate.value = initialStartDate;
      endDate.value   = initialEndDate;
    }
	  console.log("watch new values=" + startDate.value + " " + endDate.value)

    await nextTick();
    renderTimesheet();
  }
);


async function doZoom(zoomValue, sdate, edate) {
  const container = document.getElementById("planner-container")
  const sidebar = document.getElementById("sidebar")

  if (container) {
    let newDayWidth = null;
    view.setZoomVal(zoomValue);
    if (zoomValue > 0) {
      const widthA = container.getBoundingClientRect().width
      const widthB = sidebar.getBoundingClientRect().width
      const remainingWidth = Math.floor(widthA - widthB);
      let divider = 7;
      if (zoomValue === 1) {
      } else if (zoomValue === 2) {
        const { startOfMonth, endOfMonth } = getMonthRange(new Date())
        divider = daysBetween(startOfMonth, endOfMonth);
      } else if (zoomValue === 3) {
        const { startOfQuarter, endOfQuarter } = getQuarterRange(new Date())
        divider = daysBetween(startOfQuarter, endOfQuarter);
      } else if (zoomValue === 4) {
        const { startOfHalf, endOfHalf } = getHalfYearRange(new Date())
        divider = daysBetween(startOfHalf, endOfHalf);
      } else if (zoomValue === 5) {
        view.setZoomStart(sdate)
        view.setZoomEnd(edate)
        divider = daysBetween(sdate, edate, false);
      }
      newDayWidth = Math.floor(remainingWidth / divider);
    }
    view.setZoomWidthPerDay(newDayWidth)
  }

  await nextTick()
  renderTimesheet()
};

watch(activeZoomVal, async (newValue, oldValue) => {
  doZoom(newValue, activeZoomStart.value, activeZoomEnd.value)
});

const entityStartDate = ref(formatDateDDMMYYYY(new Date()));
const entityEndDate = ref(formatDateDDMMYYYY(new Date()));

const uid = ref(document.getElementById('app').dataset.uid)
console.log("uid=" + uid.value)
const localProjects = ref<any[]>([...props.projects]);
const displayProjects = computed(() => [...sortProjects(localProjects.value.filter(p => projectFilter.value.active  && p.status === 0 && (printProject.value ? printProject.value.id === p.id : true))).map(p => prepProject(p)),
                                        ...sortProjects(localProjects.value.filter(p => projectFilter.value.planned && p.status === 2)).map(p => prepProject(p))]);

const localBookings = ref<any[]>([...props.bookings]);

const undoStack = ref<any[]>([])
// Wahr, wenn die letzte Aktion bestehende Buchungen gekuerzt oder geloescht
// hat. Dann wird der Knopf ausgegraut statt zu verschwinden, damit sichtbar
// bleibt, dass es ihn gibt und warum er gerade nicht geht (TIM-53).
const undoGesperrt = ref(false)
let isUndoing = false

// Ein Fingerabdruck einer Buchung, um hinterher zu erkennen, ob eine
// bestehende gekuerzt, verschoben oder geloescht wurde (TIM-53). Nur die
// ersten zehn Zeichen des Datums, damit ein Zeitanteil nicht stoert.
function bookingSignatur(b: any) {
  return `${b.project_id}|${String(b.start).slice(0, 10)}|${String(b.end).slice(0, 10)}`
}

function pushUndo(action: any) {
  if (isUndoing) return
  undoStack.value.push(action)
  if (undoStack.value.length > 20) undoStack.value.shift()
}
// props.users enthaelt nur aktive Personen. Buchungen aller anderen muessen hier
// raus: sie bekaemen keine Zeile, wuerden vom Tageszaehler aber mitgezaehlt - die
// Zahl stand dann ueber Balken, die es nicht gibt (TIM-30).
// Der Filter sitzt bewusst hier und nicht beim Laden: nach jeder Buchungsaenderung
// ersetzt handleBookingDone localBookings durch die Antwort von /update_bookings,
// und die liefert unveraendert alle Buchungen.
const activeUserIds = computed(() => new Set(props.users.map((u: any) => u.id)));

const displayBookings = computed(() =>
  localBookings.value
    .filter(b => activeUserIds.value.has(b.user_id))
    .filter(b => projectFilter.value.all || b.user_id.toString() === uid.value.toString())
    .map(b => prepBooking(b))
);

// Bewusst ein computed und kein ref: die Filter sind Regeln, die nach jeder
// Buchungsaenderung neu ausgewertet werden muessen. Als eingefrorene Liste
// fehlte einer frisch gebuchten Person ihre Zeile (TIM-17).
const resourceFilter = computed(() =>
  computeResourceFilter(view, localProjects.value, props.users, localBookings.value)
);


const emit = defineEmits(['update:bookings', 'update:projects', 'reload'])

let leftLastTop = 0;
let leftLastLeft = 0;

let rightLastTop = 0;
let rightLastLeft = 0;


// Guard gegen das Echo der Zwei-Wege-Synchronisation: Setzen wir programmatisch
// other.scrollTop, feuert dort ein scroll-Event, das sonst el.scrollTop zurücksetzt.
// Auf iOS bricht so eine Rückzuweisung das laufende Touch-Scrollen ab ("klebt").
let suppressSync = false;

function syncScroll(source) {
  if (suppressSync) { suppressSync = false; return; }

  const el = source === 'left' ? sidebarRef.value : timesheetRef.value;
  const other = source === 'left' ? timesheetRef.value : sidebarRef.value;
  if (!el || !other) return;

  if (other.scrollTop !== el.scrollTop) {
    suppressSync = true;           // das folgende scroll-Event auf `other` ignorieren
    other.scrollTop = el.scrollTop;
  }
}

function handleSetProjectFilter(all, active, planned) {
  view.setProjectFilter(all, active, planned); 
}

function handleZoom(newZoomLevel, startdate, enddate) {
  console.log("newZoomLevel=" + newZoomLevel + " startdate=" + startdate + " enddate=" + enddate);
  activeZoomVal.value = newZoomLevel
  activeZoomStart.value = fromIso(fromGerman(startdate))
  activeZoomEnd.value = fromIso(fromGerman(enddate))
  doZoom(activeZoomVal.value, activeZoomStart.value, activeZoomEnd.value)
}

function updateProjectOpenstates(pid) {
	view.toggleProject(pid);
}

function handleUpdateResourceFilter(pid, filter) {
  // Nur in den Store schreiben — resourceFilter zieht als computed nach.
  view.setResourceFilter(pid, filter)
}


const showPopup = ref(false)
const popupTarget = ref<HTMLElement | null>(null)
const popupType = ref(null);
const popupMode = ref<string | null>(null);
const popupEntity = ref(null);
// Zeitabschnitte im Dialog, als deutsche Datumszeichenketten fuer DateInput.
const periodRows = ref<{ start: string, end: string }[]>([]);
const selectedPopupProjectId = ref<number | null>(null);

function openPopupAt(el: HTMLElement, entity) {
  console.log("openPopupAt id=" + el.id + "=" + JSON.stringify(entity))
  popupTarget.value = el
  showPopup.value = true
  popupType.value = entity.isproject ? 0 : 1;
  popupMode.value = entity.isproject ? 'datechange' : 'context';
  entityStartDate.value = toGerman(entity.start);
  entityEndDate.value = toGerman(entity.end);
  popupEntity.value = entity;
  if (entity.isproject) {
    const project = localProjects.value.find((p: any) => p.id === entity.id)
    const periods = projectPeriods(project ?? { start: entity.start, end: entity.end })
    periodRows.value = periods.map((pd: any) => ({ start: toGerman(pd.start), end: toGerman(pd.end) }))
  }
  if (!entity.isproject) {
    const booking = localBookings.value.find((b: any) => b.id === entity.id)
    selectedPopupProjectId.value = booking ? booking.project_id : null
  }
}

function closePopup() {
  showPopup.value = false
  closeSelection();		
}

// Zentrale Konfliktauflösung: prüft Fremdbuchungen derselben Person im Zielzeitraum,
// zeigt bei Bedarf den 3-Optionen-Dialog und liefert die anzuwendende Spanne zurück.
// Rückgabe: [startIso, endIso] (anwenden) oder null (abbrechen).
async function resolveConflict({ userId, excludeId, startIso, endIso, origStartIso, origEndIso }) {
  const conflict = findNearestConflict(localBookings.value, userId, excludeId, startIso, endIso, origStartIso, origEndIso)
  if (!conflict) return [startIso, endIso]
  if (conflict.isVacation) {
    alert('Umbuchungen von/über Urlaubsbuchungen nicht möglich. Bitte zuerst frei machen.')
    return null
  }
  const proj = displayProjects.value.find((p: any) => p.id === conflict.booking.project_id)
  const user = props.users.find((u: any) => u.id === userId)
  const clipped = clipRangeAgainstConflict(startIso, endIso, conflict.booking, conflict.side)
  const choice = await conflictModal.value.open({
    userName: user ? `${user.firstname} ${user.lastname}` : `Person ${userId}`,
    projectName: proj ? proj.name : `Projekt ${conflict.booking.project_id}`,
    projectColor: proj ? proj.color : null,
    startLabel: toGerman(conflict.booking.start, '.'),
    endLabel: toGerman(conflict.booking.end, '.'),
    partialAvailable: clipped != null,
  })
  if (choice === 'cancel') return null
  if (choice === 'partial') return clipped
  return [startIso, endIso]  // overwrite: volle Spanne, Backend schneidet die Fremdbuchung zurecht
}

// Provide the API for children
provide(POPUP_BUS, { openPopupAt, closePopup, resolveConflict })

// Anfang und Ende koennen sich nicht mehr ueberkreuzen: schiebt man den Anfang
// hinter das Ende, wandert das Ende mit, und umgekehrt. Vorher liess sich so
// eine Buchung mit Ende vor Anfang bauen - der Server brach dann ab, und die
// Meldung kam als "undefined" beim Nutzer an. Siehe TIM-54.
function handleStartDateChange(d) {
  entityStartDate.value = d;
  if (fromGerman(d) > fromGerman(entityEndDate.value)) entityEndDate.value = d;
}

function handleEndDateChange(d) {
  entityEndDate.value = d;
  if (fromGerman(d) < fromGerman(entityStartDate.value)) entityStartDate.value = d;
}

const popupProjects = computed(() => {
  if (!popupEntity.value || popupEntity.value.isproject) return []
  const booking = localBookings.value.find((b: any) => b.id === popupEntity.value.id)
  const currentPid = booking ? booking.project_id : null
  const currentProject = displayProjects.value.find((p: any) => p.id === currentPid)
  const others = displayProjects.value.filter((p: any) => p.id !== currentPid && p.id !== 0 && !p.isspacer)
  return currentProject ? [currentProject, ...others] : others
})

const compatibleProjectIds = computed(() => {
  if (!entityStartDate.value || !entityEndDate.value) return new Set<number>()
  const bStart = fromGerman(entityStartDate.value)
  const bEnd = fromGerman(entityEndDate.value)
  if (!bStart || !bEnd) return new Set<number>()
  return new Set<number>(
    displayProjects.value
      .filter((p: any) => p.id !== 0 && !p.isspacer && bStart <= p.end && bEnd >= p.start)
      .map((p: any) => p.id)
  )
})

watch(compatibleProjectIds, (compatible) => {
  if (selectedPopupProjectId.value !== null && !compatible.has(selectedPopupProjectId.value)) {
    selectedPopupProjectId.value = popupProjects.value[0]?.id ?? null
  }
})

function shiftDate(dateStr: string, days: number): string {
  const iso = fromGerman(dateStr)
  if (!iso) return dateStr
  return toGerman(addDays(iso, days))
}

// Neuer Abschnitt hinter dem letzten, mit einer vollen Woche Pause dazwischen -
// sonst wuerde er beim Speichern sofort wieder verschmolzen.
function addPeriodRow() {
  const last = periodRows.value[periodRows.value.length - 1]
  const from = last ? addDays(fromGerman(last.end), 8) : toIsoLocal(new Date())
  periodRows.value.push({ start: toGerman(from), end: toGerman(addDays(from, 6)) })
}

// Abschnitte speichern. Zuerst fragt der Server im Vorschaumodus, was mit den
// Buchungen geschehen WUERDE - faellt dabei etwas an, wird zurueckgefragt,
// bevor wirklich geaendert wird.
function handlePeriodsApply() {
  const entity = popupEntity.value
  const periods = periodRows.value
    .map((r: any) => ({ start: fromGerman(r.start), end: fromGerman(r.end) }))
    .filter((r: any) => r.start && r.end)

  if (periods.length === 0) {
    alert('Es muss mindestens ein Zeitabschnitt bleiben.')
    return
  }
  if (periods.some((r: any) => r.end < r.start)) {
    alert('Ein Abschnitt endet vor seinem Anfang.')
    return
  }

  closePopup()
  isLoading.value = true
  sendRequest('/update_project_periods', { id: entity.id, periods, preview: true }, async function(vorschau) {
    isLoading.value = false
    const c = vorschau['changed_bookings'] || {}
    const teile = []
    if (c.trimmed) teile.push(`${c.trimmed} gekürzt`)
    if (c.deleted) teile.push(`${c.deleted} entfernt`)
    if (c.split)   teile.push(`${c.split} in zwei einzelne geteilt`)

    if (teile.length > 0) {
      modalMessage.value = `Änderungen bei Buchungen: ${teile.join(', ')}`
      modalColsItems.value = []
      modalItems.value = []
      modalCancelable.value = true
      const ok = await confirmModal.value.open()
      modalCancelable.value = false
      if (!ok) {
        updatePlanner()
        return
      }
    }
    savePeriods(entity, periods)
  }, function(response) {
    isLoading.value = false
    alert(response['error'])
    updatePlanner()
  })
}

// Die Abschnitte wirklich schreiben.
function savePeriods(entity, periods) {
  isLoading.value = true
  sendRequest('/update_project_periods', { id: entity.id, periods }, function(response) {
    isLoading.value = false
    const project = localProjects.value.find((p: any) => p.id === entity.id)
    if (project) {
      project.periods = response['periods']
      project.start = response['start']
      project.end = response['end']
    }
    // Ohne das zeigten die Balken weiter die alten Zeitraeume: der Server hat
    // die Buchungen an die Pausen angepasst, das Frontend wusste nichts davon.
    if (response['bookings']) localBookings.value = response['bookings']
    updatePlanner()
  }, function(response) {
    isLoading.value = false
    alert(response['error'])
    updatePlanner()
  })
}

async function handleDateChangeApply() {
  const entity = popupEntity.value;
  const isProject = entity.isproject;
  const pid = isProject ? entity.id : selectedPopupProjectId.value;

  // Projektzeitraum ändern: unverändertes Verhalten (keine Personen-Konflikte relevant).
  // firstDay/lastDay gehen als ISO raus – wie schon auf dem Undo-Pfad (projectChangeDone).
  if (isProject) {
    closePopup();
    projectChangeDone({
      isproject: true, id: entity.id, booking_action: pid, selected_pid: pid, selected_bid: null,
      firstDay: fromGerman(entityStartDate.value), lastDay: fromGerman(entityEndDate.value), newpstart: null, newpend: null,
      selectedResources: [entity.uid], shift: false, changedir: false,
    });
    return;
  }

  // Buchungszeitraum ändern: ISO-Spanne, Konfliktprüfung, dann Projektzeitraum-Prüfung.
  let startIso = fromGerman(entityStartDate.value);
  let endIso = fromGerman(entityEndDate.value);
  const booking = localBookings.value.find((b: any) => b.id === entity.id);
  closePopup();

  const resolved = await resolveConflict({
    userId: entity.uid, excludeId: entity.id, startIso, endIso,
    origStartIso: booking ? booking.start : null, origEndIso: booking ? booking.end : null,
  });
  if (!resolved) return;
  [startIso, endIso] = resolved;

  const project = displayProjects.value.find((p: any) => p.id === pid);
  const [validate, extend, ps, pe] = validateProjectDuration(project, startIso, endIso);
  if (!validate) return;

  handleBookingDone({
    isproject: false, id: entity.id, booking_action: pid, selected_pid: pid, selected_bid: entity.id,
    firstDay: startIso, lastDay: endIso, newpstart: extend ? ps : null, newpend: extend ? pe : null,
    selectedResources: [entity.uid], shift: false, changedir: false,
  }, null);
}

async function handleMoveApply() {
  const booking = localBookings.value.find((b: any) => b.id === popupEntity.value.id);
  const targetProjectId = (selectedPopupProjectId.value !== null && selectedPopupProjectId.value !== booking?.project_id)
    ? selectedPopupProjectId.value
    : null;
  closePopup();
  if (targetProjectId === null || !booking) return;

  const oldProjectId = booking.project_id;
  const userId = booking.user_id;

  const resolved = await resolveConflict({
    userId, excludeId: booking.id, startIso: booking.start, endIso: booking.end,
    origStartIso: booking.start, origEndIso: booking.end,
  });
  if (!resolved) return;
  const [startIso, endIso] = resolved;

  const project = displayProjects.value.find((p: any) => p.id === targetProjectId);
  const [validate, extend, newpstart, newpend] = validateProjectDuration(project, startIso, endIso);
  if (!validate) return;

  handleBookingDone({
    booking_action: targetProjectId,
    selected_pid: targetProjectId,
    selected_bid: booking.id,
    firstDay: startIso,
    lastDay: endIso,
    newpstart: extend ? newpstart : null,
    newpend: extend ? newpend : null,
    selectedResources: [userId],
  }, function() {
    // Frueher wurde die Sichtbarkeitsliste beider Projekte hier von Hand
    // nachgezogen. Das entfaellt: resourceFilter wertet die Regel bei jeder
    // Buchungsaenderung ohnehin neu aus.
    updatePlanner();
  });
}

function handleDeleteFromContext() {
  if (!popupEntity.value) return;
  const bookingId = popupEntity.value.id;
  const booking = localBookings.value.find((b: any) => b.id === bookingId);
  if (!booking) return;
  pushUndo({ type: 'deletedBooking', booking: { ...booking } });
  localBookings.value = localBookings.value.filter((b: any) => b.id !== bookingId);
  isLoading.value = true;
  closePopup();
  sendRequest(`/bookings/${bookingId}`, {}, function() {
    isLoading.value = false;
    updatePlanner();
  }, function(response) {
    undoStack.value.pop();
    localBookings.value.push(booking);
    isLoading.value = false;
    alert(response.error || 'Fehler beim Löschen');
    updatePlanner();
  }, 'DELETE');
}

function updatePlanner() {
	closeSelection();	
	//emit('reload');
}

function handleBookingDone(params, afterSuccess: (() => void) | null = null) {
  // Zustand VOR der Aktion. Der Server kuerzt, teilt oder loescht beim Buchen
  // alles, was im gewaehlten Zeitraum liegt (update_booking im Controller).
  // Rueckgaengig kann das niemand, weil der Vorzustand nirgends gesichert wird
  // - der Undo-Zweig loescht nur die neu entstandenen Buchungen und macht die
  // Luecke damit sogar groesser. Deshalb hinterher vergleichen und in so einem
  // Fall gar kein Rueckgaengig anbieten. Siehe TIM-53.
  undoGesperrt.value = false
  const zustandVorher = new Map(localBookings.value.map((b: any) => [b.id, bookingSignatur(b)]))
  let undoGepusht = false

  if (params.selected_bid) {
    const old = localBookings.value.find((b: any) => b.id === params.selected_bid)
    if (old) {
      pushUndo({ type: 'booking', params: { ...params, booking_action: old.project_id, selected_pid: old.project_id, firstDay: old.start, lastDay: old.end, newpstart: null, newpend: null } })
      undoGepusht = true
    }
  }
  const previousIds = new Set(localBookings.value.map((b: any) => b.id))

  // Optimistic update for new bookings (no project date extension, not a clear action)
  const isOptimistic = !params.selected_bid && params.booking_action >= 0 && !params.newpstart
  let tempIds: string[] = []
  let previousBookings: any[] = []

  if (isOptimistic) {
    // firstDay/lastDay sind ISO – dasselbe, was der Server gleich zurückliefert.
    const startStr = params.firstDay as string
    const endStr   = params.lastDay as string
    previousBookings = [...localBookings.value]
    const now = Date.now()
    tempIds = (params.selectedResources as number[]).map((_: any, i: number) => `temp-${now}-${i}`)
    localBookings.value = [...localBookings.value, ...(params.selectedResources as number[]).map((uid: number, i: number) => ({
      id: tempIds[i], start: startStr, end: endStr, user_id: uid, project_id: params.booking_action,
    }))]
  } else {
    isLoading.value = true
  }

  sendRequest('/update_bookings', params, function(bookings) {
    isLoading.value = false
    localBookings.value = bookings

    localProjects.value = localProjects.value.map((p: any) => {

      // newpstart/newpend kommen als ISO aus validateProjectDuration – direkt
      // übernehmbar (vorher wurden hier zwei nicht importierte Funktionen
      // aufgerufen, was den Zweig zum ReferenceError machte).
      if (params["selected_pid"] === p.id && params["newpstart"]) {
        return {
          ...p,
          start: params["newpstart"],
          end: params["newpend"]
        }
      }

      return p
    })
    // Ist eine Buchung, die es vorher gab, verschwunden oder veraendert? Die
    // gerade bearbeitete ist ausgenommen, ihre Aenderung ist ja gewollt.
    const bestehendeZerstoert = [...zustandVorher].some(([id, sig]) => {
      if (id === params.selected_bid) return false
      const jetzt = bookings.find((b: any) => b.id === id)
      return !jetzt || bookingSignatur(jetzt) !== sig
    })

    if (bestehendeZerstoert) {
      // Rueckgaengig waere hier eine Falle: es wuerde die neuen Buchungen
      // loeschen und die alten trotzdem nicht zurueckbringen.
      if (undoGepusht) undoStack.value.pop()
      undoGesperrt.value = true
    } else if (!params.selected_bid && params.booking_action !== -1) {
      const newIds = bookings.filter((b: any) => !previousIds.has(b.id)).map((b: any) => b.id)
      if (newIds.length > 0) pushUndo({ type: 'newBooking', bookingIds: newIds })
    }
    if (afterSuccess) afterSuccess();
    else updatePlanner();
  }, function(response) {
    if (isOptimistic) localBookings.value = previousBookings
    isLoading.value = false
    alert(response.error);
    updatePlanner();
  });
}

function projectChangeDone(params) {
	undoGesperrt.value = false
	const old = localProjects.value.find((p: any) => p.id === params.selected_pid)
	let undoGepusht = false
	if (old) {
		pushUndo({ type: 'projectChange', params: { ...params, firstDay: old.start, lastDay: old.end } })
		undoGepusht = true
	}
	isLoading.value = true
	sendRequest('/change_project_date', params, function(response) {
		isLoading.value = false
		localProjects.value = response["projects"]
		let affected_bookings = response["affected_bookings"]
		modalMessage.value = "Folgende Buchungen sind betroffen"
		modalColsItems.value = colscollisions
		modalItems.value = affected_bookings
		console.log("affected_bookings=" + JSON.stringify(affected_bookings))
		if (affected_bookings.length > 0) {
			// Der Zeitraumwechsel hat Buchungen gekuerzt oder geloescht. Das
			// Rueckgaengig setzt nur den Zeitraum zurueck und laesst die
			// Buchungen verschwunden - also gar nicht erst anbieten (TIM-53).
			if (undoGepusht) undoStack.value.pop()
			undoGesperrt.value = true
			confirmModal.value.open();			
		}
    updatePlanner()
	}, function(response) {
		isLoading.value = false
		alert(response['error']);
    updatePlanner()
	});
}

function performUndo() {
  const action = undoStack.value.pop()
  if (!action) return
  isUndoing = true
  isLoading.value = true
  if (action.type === 'booking') {
    sendRequest('/update_bookings', action.params, function(bookings) {
      isLoading.value = false
      localBookings.value = bookings
      updatePlanner()
      isUndoing = false
    }, function(response) {
      isLoading.value = false
      alert(response.error)
      updatePlanner()
      isUndoing = false
    })
  } else if (action.type === 'newBooking') {
    const token = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content
    Promise.all(
      action.bookingIds.map((id: number) =>
        fetch(`/bookings/${id}`, { method: 'DELETE', headers: { 'X-CSRF-Token': token, 'Accept': 'application/json' } })
      )
    ).then(() => {
      sendRequest('/bookings.json', {}, function(bookings) {
        isLoading.value = false
        localBookings.value = bookings
        updatePlanner()
        isUndoing = false
      }, function() { isLoading.value = false; isUndoing = false }, 'GET')
    }).catch(() => {
      isLoading.value = false
      isUndoing = false
      alert('Fehler beim Rückgängig machen')
    })
  } else if (action.type === 'projectChange') {
    sendRequest('/change_project_date', action.params, function(response) {
      isLoading.value = false
      localProjects.value = response["projects"]
      updatePlanner()
      isUndoing = false
    }, function(response) {
      isLoading.value = false
      alert(response['error'])
      updatePlanner()
      isUndoing = false
    })
  } else if (action.type === 'deletedBooking') {
    const b = action.booking
    const params = {
      isproject: false,
      booking_action: b.project_id,
      selected_pid: b.project_id,
      selected_bid: null,
      firstDay: b.start,
      lastDay: b.end,
      selectedResources: [b.user_id],
      shift: false,
      changedir: false,
    }
    sendRequest('/update_bookings', params, function(bookings) {
      isLoading.value = false
      localBookings.value = bookings
      updatePlanner()
      isUndoing = false
    }, function(response) {
      isLoading.value = false
      alert(response.error)
      isUndoing = false
    })
  }
}

function deleteSelectedBooking() {
  const selected = (document.querySelector('.task.highlight-bar') || document.querySelector('.task.editable')) as HTMLElement | null
  if (!selected) return

  const parts = selected.id.split('-')
  if (parts.length < 3) return  // Projektzeile, keine Buchung

  const bookingId = parseInt(parts[parts.length - 1])
  if (isNaN(bookingId)) return

  const booking = localBookings.value.find((b: any) => b.id === bookingId)
  if (!booking) return

  pushUndo({ type: 'deletedBooking', booking: { ...booking } })
  localBookings.value = localBookings.value.filter((b: any) => b.id !== bookingId)
  isLoading.value = true
  closePopup()

  sendRequest(`/bookings/${bookingId}`, {}, function() {
    isLoading.value = false
    updatePlanner()
  }, function(response) {
    isLoading.value = false
    undoStack.value.pop()
    localBookings.value.push(booking)
    alert(response.error || 'Fehler beim Löschen')
    updatePlanner()
  }, 'DELETE')
}

function handleDateUpdate(startdate, enddate) {
	console.log("handleDateUpdate startdate, enddate=" + startdate +  " " +  enddate);
	
	let startDate = fromIso(fromGerman(startdate));
	let endDate   = fromIso(fromGerman(enddate));

	const rect = document.querySelector(".selection-rectangle") as HTMLElement | null;
	if (!rect) {
		return;
	}

	const x = xScaleRef.value;
	if (!x) return;

	// Die linke Kante aus dem Startdatum berechnen, nicht aus dem bestehenden
	// Rechteck ablesen: sonst bleibt sie beim Ändern des Starts stehen und nur die
	// Breite wächst – sichtbar wandert dann das Ende statt des Anfangs.
	// setDim rastet ohnehin auf ganze Tagesspalten, der 1-h-Versatz zwischen
	// Achsen-Raster (lokal) und fromIso (UTC) fällt dabei weg.
	const newleft = cleanx(x, startDate);
	const newWidth = cleanx(x, endDate) - newleft + getWidthPerDay(printProject.value !== null, view.zoomWidthPerDay);
	setDim(rect, newleft, parseFloat(rect.style.top), newWidth, parseFloat(rect.style.height), dayWidth, getRowHeight(printProject.value !== null));
}

function handleCancel() {
   console.log("reload in D3Planner")
   emit('reload')
}

function closeSelection() {
  removeSelections()
  document.getElementById("timesheet").classList.remove("disable-selection");
  const selectionLayer = document.getElementById('selection-layer');
  if (!selectionLayer) {
	return
  }
  let sel = selectionLayer.querySelector('.selection-rectangle');
  if (sel) {
    sel.remove();
	selectionPopupRef.value?.handleSelectionClose();
  }		
}  

function renderTimesheet() {
	console.log("startDateStr=" + startDateStr)
	console.log("startDate=" + startDate.value)
	console.log("endDate=" + endDate.value)

	endDate.value = nextDay(endDate.value);

	let widthPerDay= getWidthPerDay(printProject.value !== null, view.zoomWidthPerDay)
    const totalDays = (endDate.value.getTime() - startDate.value.getTime()) / dayMs;

    const x = d3.scaleUtc().domain([startDate.value, endDate.value]).range([0, totalDays * widthPerDay]);

    xScaleRef.value = x;

    let dayWidth = cleanx(x, new Date(2024, 0, 2)) - cleanx(x, new Date(2024, 0, 1));

	const timesheet = document.getElementById("timesheet");
	timesheet.style.width = `${totalDays * widthPerDay}px`;

	const sidebar = document.getElementById("sidebar");
	const mainScrollArea = document.getElementById("main-scroll-area");

    const days = d3.timeDay.range(startDate.value, endDate.value);
	daysRef.value = days;

	//console.log("holidays=" + JSON.stringify(holidays))


	const selectionLayer = document.getElementById('selection-layer');

	document.addEventListener("keydown", e => {
		if (e.code === "Escape") {
			closeSelection();
		}
		if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
			e.preventDefault()
			performUndo()
		}
		if (e.code === 'Backspace' && !(e.target as Element).closest('input, textarea, select, [contenteditable]')) {
			e.preventDefault()
			deleteSelectedBooking()
		}
	})


  let longPressTimer: number
	let startX = 0
	let startY = 0
	const LONG_PRESS_THRESHOLD = 500 // ms
	const MOVE_THRESHOLD = 10 // pixels

	if (printProject.value) {
	  //no need to allow listeners
	  return;
	}
	timesheet.addEventListener("pointerdown", e => {
	  if ((e.target as Element).closest(".task") || (e.target as Element).closest(".selection-rectangle") || (e.target as Element).closest(".project-row")) return;

    window.__POINTER_DOWN__ = true;

	  document.querySelectorAll(".task.editable").forEach(t => t.classList.remove("editable"));

	  startX = e.clientX
	  startY = e.clientY
	  let moved = false
	  let longPressTriggered = false

	  // Langes Druecken ist eine Geste fuer Finger und Stift - mit der Maus zieht
	  // man auf, sobald man sich bewegt. Vorher lief der Zeitgeber fuer jedes
	  // Eingabegeraet, man musste also auch am Rechner erst warten.
	  const istZeigegeraet = e.pointerType === "mouse"

	  const auswahlBeginnen = () => {
	    longPressTriggered = true
	    closeSelection()
	    selectionPopupRef.value?.handleSelectionClose();
	    startSelectionRectangle(e)
	  }

	  if (!istZeigegeraet) {
	    longPressTimer = window.setTimeout(auswahlBeginnen, LONG_PRESS_THRESHOLD)
	  }

	  const onPointerMove = (ev: PointerEvent) => {
	    const dx = ev.clientX - startX
	    const dy = ev.clientY - startY
	    if (Math.hypot(dx, dy) > MOVE_THRESHOLD) {
	      moved = true
	      clearTimeout(longPressTimer)
	      timesheet.removeEventListener("pointermove", onPointerMove)
	      timesheet.removeEventListener("pointerup", onPointerUp)
	      // Mit der Maus ist genau das die Geste zum Aufziehen. Beim Finger
	      // bedeutet Bewegung dagegen scrollen - dort bleibt es beim langen
	      // Druecken, und der Zeitgeber ist oben schon abgeraeumt.
	      if (istZeigegeraet) auswahlBeginnen()
	    }
	  }

	  const onPointerUp = (ev: PointerEvent) => {
	    clearTimeout(longPressTimer)
	    timesheet.removeEventListener("pointermove", onPointerMove)
	    timesheet.removeEventListener("pointerup", onPointerUp)

      window.__POINTER_DOWN__ = false;

	    if (!longPressTriggered && !moved) {
	      // Short tap / click
	      closeSelection()
	      startSelectionRectangle(ev, true)
	    }
	    // else: either long press triggered or user dragged → do nothing
	  }

	  timesheet.addEventListener("pointermove", onPointerMove)
	  timesheet.addEventListener("pointerup", onPointerUp)
	})


	// Assume `closeSelection()` is your deselect callback
	function enableTouchDeselect(timesheetEl: HTMLElement) {
	  const onTouchStart = (e: TouchEvent) => {
	    // Only trigger if selection is active and user taps outside rectangle
	    const target = e.target as HTMLElement
	    if (!target.closest(".selection-rectangle")) {
	      closeSelection()
	      removeListeners()
	    }
	  }

	  const removeListeners = () => {
	    timesheetEl.removeEventListener("touchstart", onTouchStart)
	  }

	  timesheetEl.addEventListener("touchstart", onTouchStart)
	}

	// Usage: when selection is active on touch devices
	function onSelectionActivated() {
	  if ("ontouchstart" in window) {
	    enableTouchDeselect(timesheet)
	  }
	}

		
	timesheet.addEventListener('contextmenu', e => {
	  e.preventDefault(); // block long-press context menu
	});

	function startSelectionRectangle(e, immediate = false) {
	  //enableTouchDeselect(timesheet);
	  closePopup();
	  timesheet.classList.add("disable-selection");
	  const rect = document.createElement("div");
	  const openPopup = () => {
		  let b = box2int({x: rect.style.left,
			                 y: rect.style.top,
						           width: rect.style.width,
						          height: rect.style.height });
	    console.log("b=" + JSON.stringify(b));
		  selectionPopupRef.value?.handleSelectionComplete(b);
	  } 

	  rect.removeEventListener("click", openPopup);
	  rect.className = "selection-rectangle";
	  selectionLayer.appendChild(rect);

	  const containerRect = selectionLayer.getBoundingClientRect();
	  const startX = e.clientX - containerRect.left;
	  const startY = e.clientY - containerRect.top;
	  console.log("startX=" + startX + " startY=" + startY)

	  const rh = getRowHeight(printProject.value !== null)
	  setDim(rect, startX, startY, dayWidth, rh, dayWidth, rh);

	  // Vor dem immediate-Zweig, weil addResizeHandlesTo darunter darauf zugreift:
	  // stuende die Definition weiter unten, waere container beim fruehen return
	  // nie ausgefuehrt und der spaetere Griff-Handler liefe in einen
	  // ReferenceError.
	  const container = document.querySelector('.main-scroll-area');

    let initialScroll = container.scrollLeft

	  if (immediate) {
		  // Tag unter dem Tap als ISO – Vergleich gegen den Projektzeitraum (ebenfalls ISO).
		  let clickDay = xToIso(x, startX);
		  let p = getProjectFromRow(e, displayProjects.value);
		  if (!p || clickDay < p.start || clickDay > p.end) {
			  closeSelection();
			  return;
	  	}
		  // Auch die Ein-Tages-Auswahl aus einem einfachen Klick bekommt Anfasser.
		  // Vorher hingen die nur am Loslassen nach einem Zug, den es hier nicht
		  // gibt - die Box liess sich danach nicht mehr veraendern (TIM-9).
		  addResizeHandlesTo(rect);
		  openPopup();
		  return;		
	  }

	  const onMove = e2 => {
		  handleAutoScroll(e2);

		  const scrollDiff = container.scrollLeft - initialScroll;

	    const dx = e2.clientX - containerRect.left + scrollDiff;
	    const dy = e2.clientY - containerRect.top;

	    const left = Math.min(startX, dx);
	    const top = Math.min(startY, dy);
	    const width = Math.max(Math.abs(dx - startX), dayWidth);
	    const height = Math.max(Math.abs(dy - startY), rh);

	    setDim(rect, left, top, width, height, dayWidth, rh)
	  }

	  const onUp = e2 => {
	    timesheet.removeEventListener("pointermove", onMove);
	    timesheet.removeEventListener("pointerup", onUp);
      window.__POINTER_DOWN__ = false;
	    snapSelectionRectangleToGrid(rect);
	    rect.addEventListener("click", openPopup);
	  };

	  timesheet.addEventListener("pointermove", onMove);
	  timesheet.addEventListener("pointerup", onUp);

	  function snapSelectionRectangleToGrid(rect) {
	    const left = parseFloat(rect.style.left);
	    const top = parseFloat(rect.style.top);
	    const width = Math.max(parseFloat(rect.style.width), dayWidth);
	    const height = Math.max(parseFloat(rect.style.height), rh);

	    setDim(rect, left, top, width, height, dayWidth, rh);
	  	  
	    addResizeHandlesTo(rect);
	    openPopup();
	  }

	  function addResizeHandlesTo(rect) {
	    // snapSelectionRectangleToGrid läuft nach jedem Loslassen, auch nach einem
	    // Resize – ohne diesen Riegel käme jedes Mal ein weiterer Satz Griffe dazu.
	    if (rect.querySelector('.resize-handle')) return;

	    // Nur die Ecken: Die Kantengriffe lagen dicht an den Ecken und waren
	    // schwer zu treffen, ohne dass man die gewuenschte Ecke verfehlt.
	    const positions = ['nw', 'ne', 'se', 'sw'];

	    for (const pos of positions) {
	      const handle = document.createElement("div");
	      handle.className = `resize-handle ${pos}`;
	      rect.appendChild(handle);

	      setupResizeHandle(handle, rect, pos);
	    }
      }

	  function setupResizeHandle(handle, rect, position) {
	    handle.addEventListener("pointerdown", e => {
	      e.stopPropagation();
	      e.preventDefault();

        selectionPopupRef.value?.handleSelectionClose();
        window.__POINTER_DOWN__ = true;
        
        let initialScroll = container.scrollLeft
	      const startX = e.clientX;
	      const startY = e.clientY;
	      const startLeft = parseFloat(rect.style.left);
	      const startTop = parseFloat(rect.style.top);
	      const startWidth = parseFloat(rect.style.width);
	      const startHeight = parseFloat(rect.style.height);

		    const onMove = e2 => {
		      handleAutoScroll(e2); 
			
			    const scrollDiff = container.scrollLeft - initialScroll;

          const dx = (e2.clientX - startX) + scrollDiff;
			    const dy = e2.clientY - startY;
			
			    let newLeft = startLeft;
			    let newTop = startTop;
			    let newWidth = startWidth;
			    let newHeight = startHeight;

			    if (position.includes("e")) {
				    newWidth = startWidth + dx;
			    }
			    if (position.includes("s")) {
				    newHeight = startHeight + dy;
		      }
			    if (position.includes("w")) {
				    newLeft = startLeft + dx;
			    }
			    if (position.includes("n")) {
				    newTop = startTop + dy;
			    }

			    // Aufs Raster runden. Beim West- und Nordgriff wird NUR die bewegte
			    // Kante gerundet, die Ausdehnung danach aus der festen Kante
			    // abgeleitet. Vorher wurden Position und Groesse einzeln gerundet -
			    // dabei wanderte die gegenueberliegende Kante mit, obwohl man sie gar
			    // nicht angefasst hatte (TIM-9, vierter Punkt).
			    newLeft = Math.round(newLeft / dayWidth) * dayWidth;
			    newTop = Math.round(newTop / rh) * rh;

			    newWidth = position.includes("w")
			      ? (startLeft + startWidth) - newLeft
			      : Math.round(newWidth / dayWidth) * dayWidth;
			    newHeight = position.includes("n")
			      ? (startTop + startHeight) - newTop
			      : Math.round(newHeight / rh) * rh;

			    // Mindestgroesse. Beim West-/Nordgriff muss dabei die bewegte Kante
			    // zurueck, sonst verschiebt sich doch wieder die feste.
			    if (newWidth < dayWidth) {
			      if (position.includes("w")) newLeft = (startLeft + startWidth) - dayWidth;
			      newWidth = dayWidth;
			    }
			    if (newHeight < rh) {
			      if (position.includes("n")) newTop = (startTop + startHeight) - rh;
			      newHeight = rh;
			    }

			    setDim(rect, newLeft, newTop, newWidth, newHeight, dayWidth, rh);
		    };

	      const onUp = () => {
	        document.removeEventListener("pointermove", onMove);
	        document.removeEventListener("pointerup", onUp);
	        snapSelectionRectangleToGrid(rect);
	      };

	      document.addEventListener("pointermove", onMove);
	      document.addEventListener("pointerup", onUp);
	    });
	  }
	}
	
  let scrollDay = new Date();
  if (view.zoomVal === 4) {
     scrollDay = new Date(view.zoomStart);
  }

  	// add a vertical line for today's date'
	if (!printProject.value) {
	  positionTodayLine("today-line", x, scrollDay);
	}
	
	scrollToDate(x, scrollDay, view);
}


function handlePrintAction(project, start, end) {
   console.log("printview p=" + project.name + " start=" + start + " end=" + end)

   printProject.value = project;
   printStart.value = start;
   printEnd.value = end;
}

function handleRestorePlanner() {
   printProject.value = null;
   printStart.value = null;
   printEnd.value = null;
}


onMounted(() => {

  window.__POINTER_DOWN__ = false;

  window.addEventListener("pointerdown", () => {
    window.__POINTER_DOWN__ = true;
  });

  window.addEventListener("pointerup", () => {
    window.__POINTER_DOWN__ = false;
  });

  window.addEventListener("pointercancel", () => {
    window.__POINTER_DOWN__ = false;
  });

  // iPad fallback (important!)
  window.addEventListener("touchend", () => {
    window.__POINTER_DOWN__ = false;
  });

  setInterval(() => {
    if (!window.__POINTER_DOWN__) {
      stopAutoScroll();
    }
  }, 50);

  renderTimesheet();
});
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: sans-serif;
}

.scheduler-wrapper {
  display: grid;
  grid-template-rows: auto 1fr;
  width: fit-content;
  height: 100vh;
  position: relative;
  overflow: visible;
}

.corner {
  grid-column: 1;
  grid-row: 1;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  height: 96px;
}

#sidebar {
  grid-column: 1;
  grid-row: 2;
  overflow-y: auto;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  font-size: 12px;
  padding-bottom: 6px;
}

#sidebar.printview {
  background: white !important;
  border-top: 2px solid black;
}



.sidebar-group {
  font-weight: bold;
  background: #ddd;
  padding: 4px;
  border-bottom: 1px solid #bbb;
  cursor: pointer;
  user-select: none;
}

.sidebar-resource {
  padding-left: 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main-scroll-area {
  grid-column: 2;
  grid-row: 1 / span 2;
  overflow: auto;
  position: relative;
  background-color: white;
}

.main-scroll-area {
  scrollbar-width: auto;           /* "auto" | "thin" */
  scrollbar-color: #999 #e5e5e5;   /* thumb | track */
}

/* WebKit (Chrome, Edge, Safari) */
.main-scroll-area::-webkit-scrollbar {
  height: 66px;   /* horizontal scrollbar thickness only */
  width: auto;    /* vertical stays default */
}

.main-scroll-area::-webkit-scrollbar-track {
  background: #e5e5e5;
}

.main-scroll-area::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 8px;
  border: 3px solid #e5e5e5; /* optional padding effect */
}

.main-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #777;
}
.timesheet {
  position: relative;
  width: max-content;

  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.corner {
  grid-column: 1;
  grid-row: 1;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

#today-button {
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
}

.task.editable .resize-handle {
  display: block;
}

.resize-handle {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 24px; /* bigger touch area */
  margin: 0 -10px; /* overlap into task */
  z-index: 2;
  background: transparent;
  cursor: ew-resize;
  display: none;
  touch-action: none; /* prevent unwanted pinch-zoom or pan */
}

.resize-handle::before {
  content: "";
  position: absolute;
  top: 25%;
  bottom: 25%;
  width: 4px;
  background-color: #666;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
}

.resize-handle.left {
  left: -3px;
}

.resize-handle.right {
  right: -3px;
}

.task.editable .drag-handle {
  display: block;
}

.drag-handle {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  background-color: #444;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  cursor: grab;
  z-index: 10;
  touch-action: none;
}

.drag-handle:active {
  cursor: grabbing;
}

.selection-layer {
  position: absolute;  /* or relative if it's already inside a positioned container */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: visible;
  z-index: 1000;  /* lower than .selection-rectangle (z: 5 or 10) */
  pointer-events: none; /* so other things like tasks remain clickable */

   -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: none;
}


.selection-rectangle {
  position: absolute;
  /* Grauton statt des kraeftigen Blaus - die Auswahl soll den Plan darunter
     nicht ueberdecken. Akzent bleibt den Anfassern vorbehalten. */
  border: 2px dashed #6b7280;
  background-color: rgba(107, 114, 128, 0.08);
  pointer-events: auto;
  z-index: 1000;
}

.selection-rectangle .resize-handle {
  position: absolute;
  /* Groesser als vorher (24px), damit man sie auf dem Tablet sicher trifft,
     dafuer weiss mit farbigem Rand statt flaechig rot. */
  width: 28px;
  height: 28px;
  background: #ffffff;
  border: 2px solid #6b7280;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  z-index: 1010;
  display: block;
  pointer-events: auto;
  box-sizing: border-box;
}

.timesheet.disable-selection {
  touch-action: none;
  user-select: none;
}

.highlight-bar {
  border: 3px solid black !important;
}

.print-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  /* Match this width to your sidebar/corner width */
  width: 250px; 
  height: 80px;
  background: #f8f9fa;
  border-top: 2px solid #ccc;
  border-right: 1px solid #ccc;
  z-index: 9999; /* Ensure it's above everything */
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
}

.footer-content {
  display: flex;
  gap: 12px;
}

.footer-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #22c55e; /* green-500 */
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 10px;
  font-weight: bold;
  transition: transform 0.1s;
}

.footer-btn:active {
  transform: scale(0.95);
}

.footer-btn.secondary {
  background: #64748b; /* slate-500 */
}


/* Positioning */
.selection-rectangle .resize-handle.nw { top: -24px; left: -12px; cursor: nwse-resize; }
.selection-rectangle .resize-handle.ne { top: -24px; right: -12px; cursor: nesw-resize; }
.selection-rectangle .resize-handle.sw { top: 100%;  left: -12px; cursor: nesw-resize; }
.selection-rectangle .resize-handle.se { top: 100%;  right: -12px; cursor: nwse-resize; }

.selection-rectangle .resize-handle.n {
  left: 50%;
  transform: translate(-50%, 0);
}

.selection-rectangle .resize-handle.n  { top: -24px; left: 50%; transform: translateX(-55%); cursor: ns-resize; }
.selection-rectangle .resize-handle.s  { top: 100%; left: 50%; transform: translateX(-55%); cursor: ns-resize; }
.selection-rectangle .resize-handle.e  { right: -12px; top: 50%; transform: translateY(-50%); cursor: ew-resize; }
.selection-rectangle .resize-handle.w  { left: -12px; top: 50%; transform: translateY(-50%); cursor: ew-resize; }



.undo-btn-enter-active, .undo-btn-leave-active { transition: opacity 0.2s, transform 0.2s; }
.undo-btn-enter-from, .undo-btn-leave-to { opacity: 0; transform: scale(0.7); }

.web-print-header {
  padding: 6px 16px 4px;
  background: white;
  border-bottom: 1px solid #ddd;
  font-family: helvetica, sans-serif;
}

.web-print-title {
  font-size: 13px;
  font-weight: bold;
}

.web-print-meta {
  font-size: 11px;
  color: #555;
  margin-top: 2px;
}

.web-print-sep {
  margin-left: 16px;
  margin-right: 4px;
}
</style>
